import React from "react";

class SomethingWentWrong extends React.Component {
  render() {
    return <div>SOMETHING WENT WRONG</div>;
  }
}
export default SomethingWentWrong;
